var GridArrangerOptions          = require("app/ui/repeaters/GridArrangerOptions"),
    HighlightsCarouselRow        = require("./HighlightsCarouselRow"),
    NoResultsView                = require("./NoResultsView"),
    PageLayout                   = require("./PageLayout"),
    PrefixedVirtualizedRepeater  = require("app/ui/repeaters/PrefixedVirtualizedRepeater"),
    RepeaterArrayDiffDataAdapter = require("enyo-ui/RepeaterArrayDiffDataAdapter"),
    RepeaterPaddedGridArranger   = require("enyo-ui/RepeaterPaddedGridArranger"),
    ScrollAnchorMemorySupport    = require("app/ui/ScrollAnchorMemorySupport"),
    ScrollerDecoratorScrollbars  = require("app/ui/ScrollerDecoratorScrollbars"),
    SearchForm                   = require("./SearchForm"),
    ThumbnailPlaceholder         = require("app/ui/thumbnails/ThumbnailPlaceholder"),
    frameThrottle                = require("enyo-perf/utils").frameThrottle,
    get                          = require("object-path").get,
    kind                         = require("enyo/kind"),
    quickMacroize                = require("enyo/macroize").quickMacroize,
    resolveThumbnailKind         = require("app/utils/resolveThumbnailKind"),
    themeVars                    = require("app/theme/variables"),
    utils                        = require("enyo/utils");

require("./PageView.less");
require("app/theme/ScrollerDecoratorScrollbars--page.less");

module.exports = kind(/** @lends  app.SearchPage.PageView.prototype */ {

    /**
     * @private
     */
    name: "app.SearchPage.PageView",

    /**
     * @private
     */
    kind: ScrollerDecoratorScrollbars,

    /**
     * @private
     */
    layoutKind: PageLayout,

    /**
     * @private
     */
    classes: "app-search-page-page-view",

    /**
     * @private
     */
    fit: true,

    /**
     * @public
     */
    scrollerPath: ".$.results.$.scroller",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * Default scroll-bars theme for desktop, minimal for mobile.
     *
     * @public
     */
    theme: "page",

    /**
     * If true, chrome will show when scrolling, hide when not scrolling.
     *
     * @type  {boolean}
     * @public
     */
    fadeChromeOnScroll: true,

    /**
     * @private
     */
    components: [{
        name:       "results",
        kind:       PrefixedVirtualizedRepeater,
        mixins:     [ScrollAnchorMemorySupport],
        classes:    "app-search-page-page-view__results",
        showTitles: true,
        components: [{
            name:    "searchForm",
            kind:    SearchForm,
            classes: "app-search-page-page-view__search-form"
        }, {
            name:    "noResults",
            kind:    NoResultsView,
            classes: "app-search-page-page-view__no-results"
        }, {
            name:    "highlights",
            kind:    HighlightsCarouselRow,
            classes: "app-search-page-page-view__highlights"
        }, {
            name:    "title",
            tag:     "h2",
            classes: "app-search-page-page-view__title"
        }],
        dataAdapterKind: RepeaterArrayDiffDataAdapter,
        drawAsync:       true,
        scrollerOptions: {
            fit:            true,
            vertical:       true,
            horizontal:     false,
            scrollChaining: false
        },
        arrangerKind:    RepeaterPaddedGridArranger,
        arrangerOptions: utils.mixin(utils.clone(GridArrangerOptions), {

            /**
             * The amount of padding the bottom of the grid.
             *
             * @return {number}  The padding
             * @public
             */
            padBottom: function() {
                return themeVars.getContentPaddingVerticalPx() * 3;
            }
        }),

        /**
         * Determine which placeholder to show.
         *
         * @return  {enyo.Control}  The placeholder kind.
         * @public
         */
        getPlaceholderKind: function() {
            return ThumbnailPlaceholder;
        },

        /**
         * Optional extra options to merge into the placeholder kind at creation
         * time.
         *
         * @type {Object=}
         * @public
         */
        placeholderOptions: {
            formFactor: "square",
            bindings:   [{
                from: ".repeater.showTitles",
                to:   ".showTitle",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showTitle  Title visibility.
                 * @return  {boolean}   Whether to show the title.
                 * @private
                 */
                transform: function(showTitle) {
                    return showTitle === undefined ? showTitle : this.get("showTitle");
                }
            }]
        },

        /**
         * Return the right kind of row depending on the type of media.
         *
         * @param   {Object}        media  The media item
         * @return  {enyo.Control}  The row kind
         * @public
         */
        getChildKind: function(media) {
            return resolveThumbnailKind(media);
        },

        /**
         * Optional extra options to merge into the child kind at creation time.
         *
         * @type {Object}
         * @public
         */
        childOptions: {
            formFactor: "square",
            bindings:   [{
                from: ".repeater.showTitles",
                to:   ".showTitle",

                /**
                 * If the repeater does not provide any info, just show the
                 * current value.
                 *
                 * @param   {?boolean}  showTitle Title visibility.
                 * @return  {boolean}   Whether to show the title.
                 * @private
                 */
                transform: function(showTitle) {
                    return showTitle === undefined ? showTitle : this.get("showTitle");
                }
            }]
        }
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".owner.active",
        to:   ".$.searchForm.isSearching",

        /**
         * Page is loading search results if it's activity state is 0.
         *
         * @param    {Number}   active  The activity of this page's controller.
         * @returns  {boolean}  Whether the controller is searching
         * @private
         */
        transform: function(active) {
            return active === 0;
        }
    }],

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService   = this.app.$.i18nService,
            state         = this.state || {},
            numHighlights = get(state, "highlights.length", null) || 0,
            numResults    = get(state, "results.length", null) || 0,
            expandPrefix,
            $highlights   = this.$.highlights,
            $title        = this.$.title,
            $results      = this.$.results,
            anchorKey     = quickMacroize("SearchPage/PageView/{$query}/{$type}", {
                query: get(state, "params.query", null),
                type:  get(state, "params.type", null)
            });

        // If results grid is empty, the prefix should expand
        expandPrefix = numHighlights === 0 && numResults === 0;

        if (expandPrefix) {
            if (!this.hasClass("expand-prefix")) {
                this.addClass("expand-prefix");
            }
            $results.$.client.set("fit", true);

            // If there are no search results of any kind, the no-results view
            // should expand and the search form should not.
            if (numHighlights === 0 && numResults === 0) {
                // Expand no-results view
                if (!this.hasClass("expand-no-results")) {
                    this.addClass("expand-no-results");
                }

                // Don't expand search form
                while (this.hasClass("expand-search-form")) {
                    this.removeClass("expand-search-form");
                }
            }

            // Otherwise, the search form should expand and the no-results view
            // should be hidden.
            else {
                // Expand search form
                if (!this.hasClass("expand-search-form")) {
                    this.addClass("expand-search-form");
                }

                // Don't expand no-results view
                while (this.hasClass("expand-no-results")) {
                    this.removeClass("expand-no-results");
                }
            }
        }

        // Prefix doesn't expand
        else {
            while (this.hasClass("expand-prefix")) {
                this.removeClass("expand-prefix");
            }
            $results.$.client.set("fit", false);

            // Don't expand search form
            while (this.hasClass("expand-search-form")) {
                this.removeClass("expand-search-form");
            }

            // Don't expand no-results view
            while (this.hasClass("expand-no-results")) {
                this.removeClass("expand-no-results");
            }
        }

        this.$.searchForm.set("state", state);

        // This.$.noResults.set("showing", hasQuery && numHighlights === 0 && numResults === 0);
        this.$.noResults.set("showing", numHighlights === 0 && numResults === 0);

        // Only show highlights if we have any.
        $highlights.set("state", state);
        $highlights.set("showing", numHighlights > 0);

        // Only show title bar if we have a results grid
        $title.set("content", i18nService.getString("app.SearchPage.PageTitle", {
            resultCount: numResults
        }));
        $title.set("showing", numResults > 0);

        // Setting new data will trigger the repeater to re-draw. Resetting the
        // anchor ensures the repeater doesn't snap to the first result and
        // scrolling the form out of view.
        $results.set("anchorKey", anchorKey);
        $results.set("data", get(state, "results", []));
        anchorKey && $results.restoreAnchor();
    }

});
